<template>
  <signal-overlay
    :id="getInstanceId(signal.instance, signal.page_number, signal.signalName)"
    :image-position-multiplier="imagePositionMultiplier"
    :document-page="documentPage"
    :file-type="fileType"
    :rotation="rotation"
    :zoom-factor="zoomFactor"
    :signal="signal"
    :show-tooltip="false"
  >
    <i-tooltip
      :target="
        '#' +
        getInstanceId(signal.instance, signal.page_number, signal.signalName)
      "
      :title="getTooltipTitle(signal)"
      :description="getTooltipText(signal)"
      :info-type="
        signal.requirement.passed
          ? iTooltipInfoTypes.SUCCESS
          : iTooltipInfoTypes.ERROR
      "
      :alignment="iTooltipAlignmentMode.TOP_MIDDLE"
    >
    </i-tooltip>
  </signal-overlay>
</template>

<script>
import SignalOverlay from './SignalOverlay';

import {
  iTooltip,
  iTooltipAlignmentMode,
  iTooltipInfoTypes,
} from '@inscribe/signal';
import { operatorMap } from '@/utils/conditions';
import { getRequirementName } from '@/utils/checks';
import { getInstanceId } from '@/utils/signalNames';

export default {
  components: {
    iTooltip,
    'signal-overlay': SignalOverlay,
  },
  props: {
    fileType: {
      type: String,
      required: true,
    },
    imagePositionMultiplier: {
      type: Object,
      required: true,
    },
    documentPage: {
      type: Node,
      default: () => null,
    },
    document: {
      type: Object,
      required: true,
    },
    rotation: {
      type: Number,
      required: true,
    },
    signal: {
      type: Object,
      required: true,
    },
    zoomFactor: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      iTooltipAlignmentMode,
      iTooltipInfoTypes,
    };
  },
  methods: {
    getInstanceId,
    getTooltipText(signal) {
      return `${getRequirementName(
        this.$store?.state?.config?.rulesSchema,
        signal.requirement.name,
      )} ${operatorMap[signal.requirement.operator] || ''} "${signal.text}"`;
    },
    getTooltipTitle(signal) {
      return `Check ${signal.requirement.passed ? 'met' : 'not met'}`;
    },
  },
};
</script>

<style lang="scss">
.overlay {
  .signal-icon-wrapper {
    $size: 22px;
    border-radius: $border-radius-default;
    height: $size;
    min-width: $size;
    width: $size;
  }

  .signal-name {
    font-size: $font-size-small;
  }
}
</style>
